// extracted by mini-css-extract-plugin
export var activeDot = "_7j-c";
export var buttonContainer = "_7j-9";
export var channelButton = "_7j-a";
export var clickable = "_7j-d";
export var content = "_7j-0";
export var contentFull = "_7j-2";
export var contentThird = "_7j-1";
export var contentWrapper = "_7j-7";
export var description = "_7j-5";
export var heightShort = "_7j-f";
export var image = "_7j-3";
export var imageContainer = "_7j-4";
export var selectButton = "_7j-e";
export var spinnerContainer = "_7j-b";
export var titleContent = "_7j-8";
export var titleWrapper = "_7j-6";